import { Row } from "react-bootstrap";

import {
  BRAND_REPORT_LABELS,
  BRAND_REPORT_SECTION_TITLE,
} from "../../../constants/brandReport.constants";
import { getBrandReportDataFlags } from "../utils/brandReportHelpers";
import BrandReportSection from "../brandReportSection";
import KeyInsights from "../keyInsights";

const BrandReportContent = ({
  selectedBrand,
  dateState,
  brandReport,
}) => {
  if (!selectedBrand || !dateState.startDate || !dateState.endDate) {
    return (
      <div className="text-center my-5">
        <h6 className="fw-bold text-muted">
          {BRAND_REPORT_LABELS.PLEASE_SEARCH_BRAND}
        </h6>
      </div>
    );
  }

  // Check if brandReport has been loaded (not initial state)
  // Initial state is { pos: null, online: null }
  // After API call, it becomes { pos: {...}, online: {...} } even if values are 0
  const isInitialState =
    brandReport?.pos === null && brandReport?.online === null;

  if (isInitialState) {
    // Data is still loading, don't show "No data" message yet
    return null;
  }

  const { hasPosData, hasOnlineData, hasNoData, isSingleSection } =
    getBrandReportDataFlags(brandReport);

  if (hasNoData) {
    return (
      <div className="text-center my-5">
        <h6 className="fw-bold text-muted">
          {BRAND_REPORT_LABELS.NO_DATA_AVAILABLE}
        </h6>
      </div>
    );
  }

  return (
    <>
      <KeyInsights data={brandReport} />
      <Row className="g-4">
        {/* POS Section */}
        {hasPosData && (
          <BrandReportSection
            title={BRAND_REPORT_SECTION_TITLE.POS}
            data={brandReport?.pos}
            isSingleSection={isSingleSection}
          />
        )}

        {/* Online Section */}
        {hasOnlineData && (
          <BrandReportSection
            title={BRAND_REPORT_SECTION_TITLE.ONLINE}
            data={brandReport?.online}
            isSingleSection={isSingleSection}
          />
        )}
      </Row>
    </>
  );
};

export default BrandReportContent;
